<template>
<div class="statisticalChartsContainer">
  <div class="chartItem">
    <div class="itemBox">
      <div class="chartBox">
        <echarts :chart-id="idName" :chart-option="options"></echarts>
      </div>
    </div>
  </div>
</div>
</template>

<script>
// import * as echarts from 'echarts'
export default {
  props: {
    flag: {
      type: Boolean,
      default: false
    },
  },
  data() {
    // console.log(`this.echartList`, this.echartList)
    // console.log(`this`, this)
      this.request.post('/front/device/install7DayStatistics')
        .then(rs => {
          console.log(rs);
        })
        .catch(error => {} )
/*       (async () => {
        const {
          code,
          msg,
          data
        } = await this.request.post('/front/device/install7DayStatistics')
        if (code != 200) {
          return this.$message.error(msg)
        }
      })()

    console.log(`data`, data) */
    // this.echartList = data
    let dataMax = 60;
    const source = {
      data: [43, 10, 28, 35],
      indicator: [{
          name: '无线烟感',
          max: dataMax,
          data: 43
        },
        {
          name: '无线感温',
          max: dataMax,
          data: 10
        },
        {
          name: '电气火灾控制器',
          max: dataMax,
          data: 28
        },
        {
          name: '无线可燃气体',
          max: dataMax,
          data: 35
        },
        // { name: '交谈服务', max: dataMax},
        // { name: '康复服务', max: dataMax},
        // { name: '助行服务', max: dataMax},
      ]
    }
    const buildSeries = function (data) {
      const helper = data.map((item, index) => {
        const arr = new Array(data.length);
        arr.splice(index, 1, item);
        return arr;
      })

      return [data, ...helper].map((item, index) => {
        return {
          name: "2020-10-11",
          type: 'radar',
          itemStyle: {
            color: '#31e586'
          },
          lineStyle: {
            color: index === 0 ? '#31e586' : 'transparent'
          },
          areaStyle: {
            color: index === 0 ? '#31e586' : 'transparent',
            opacity: 0.3
          },
          tooltip: {
            show: index === 0 ? false : true,
            formatter: function () {
              return source.indicator[index - 1].name + '不满意度：' + source.data[index - 1];
            }
          },
          z: index === 0 ? 1 : 2,
          data: [item]
        }
      })
    }

    return {
      options: {
        // backgroundColor: '#42546c',
        backgroundColor: 'rgba(29, 55, 82, 0.85)',
        tooltip: {},
         graphic: [{
          type: 'group',
          left: 'center',
          top: 'center',
          children: [{
            type: 'text',
            z: 100,
            left: 'center',
            top: 'middle',
            style: {
              fill: '#333',
              text: [''].join('\n'),
              // text: '没有找到您要查询的相关数据',
              font: '14px'
            }
          }]
        }],
        legend: { // 图例组件
          show: true,
          icon: 'rect',
          // 图例项的 icon。ECharts 提供的标记类型包括 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'也可以通过 'image://url' 设置为图片，其中 url 为图片的链接，或者 dataURI。可以通过 'path://' 将图标设置为任意的矢量路径。 
          top: '0',
          // 图例距离顶部边距
          right: '0',
          // 图例距离左侧边距
          itemWidth: 10,
          // 图例标记的图形宽度。[ default: 25 ]
          itemHeight: 10,
          // 图例标记的图形高度。[ default: 14 ]
          itemGap: 30,
          // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
          orient: 'vertical',
          // 图例列表的布局朝向,'horizontal'为横向,''为纵向.
          textStyle: { // 图例的公用文本样式。
            fontSize: 12,
            color: '#fff'
          },
          data: [{ // 图例的数据数组。数组项通常为一个字符串，每一项代表一个系列的 name（如果是饼图，也可以是饼图单个数据的 name）。图例组件会自动根据对应系列的图形标记（symbol）来绘制自己的颜色和标记，特殊字符串 ''（空字符串）或者 '\n'（换行字符串）用于图例的换行。
            name: '2020-10-11',
            // 图例项的名称，应等于某系列的name值（如果是饼图，也可以是饼图单个数据的 name）。 
            icon: 'rect',
            // 图例项的 icon。
            textStyle: { // 图例项的文本样式。
              color: 'rgba(51,0,255,1)',
              fontWeight: 'bold' // 文字字体的粗细，可选'normal'，'bold'，'bolder'，'lighter'
            }
          }, ],
        },
        radar: {
          // shape: 'circle',
          center: ['50%', '50%'],
          // 圆中心坐标，数组的第一项是横坐标，第二项是纵坐标。[ default: ['50%', '50%'] ]
          radius: 38,
          // 圆的半径，数组的第一项是内半径，第二项是外半径。
          startAngle: 90,
          name: {
            textStyle: {
              fontSize: 12,
              color: "#fff",
              //   padding: [3, 5]
            },
            rich: {
              dd: {
                fontSize: 12,
                lineHeight: 20,
                color: '#51b2b4'
              },
            },
            formatter: function (a, b) {
              // source.indexOf(a)
              //console.log(a, b)
              return '{dd|' + a + '}' + "：\n增" + b.data;
            }
          },
          splitNumber: 4,
          splitArea: {
            show: true,
            areaStyle: {
              color: ['rgba(12,62,129,0)', 'rgba(12,62,129,0.3)', 'rgba(12,62,129,0)', 'rgba(12,62,129,0)']
            }
          },
          splitLine: {
            lineStyle: {
              color: '#0c3e81'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#0c3e81'
            }
          },
          indicator: source.indicator
        },
        series: buildSeries(source.data)
      },
      echartList: []
    }
  },
  //数据自动刷新，必然需要一个监听机制告诉Echarts重新设置数据
  /* watch: {
    //观察option的变化
    options: {
      handler(newVal, oldVal) {
        if (this.myChart1) {
          if (newVal) {
            this.myChart1.setOption(newVal);
          } else {
            this.myChart1.setOption(oldVal);
          }
        } else {
          this.init();
        }
      },
      deep: true //对象内部属性的监听，关键。
    },
  }, */
  created() {
    this.initStyle()
    this.getEchartList()
  },
  computed: {
    idName() {
      return this.flag ? "echartsId3_big" : "echartsId3"
    },
    styleObj() {
      return this.flag ? {
        radius: 250
      } : {
        radius: 38
      }
    }
  },
  mounted() {},
  methods: {
    initStyle() {
      this.options.radar.radius = this.styleObj.radius
    },
  /*   init() {
      // 基于准备好的dom，初始化echarts实例
      let myChart1 = echarts.init(document.getElementById(this.idName))
      myChart1.setOption(this.options, true)
    }, */
    async getEchartList() {
      const {
        code,
        msg,
        data
      } = await this.request.post('/front/device/install7DayStatistics')
      if (code != 200) {
        // return this.$message.error(msg)
        return
      }
      if(data.length<1){
        this.options.graphic[0].children[0].style.text= ['没有找到您要查询的相关数据']
        return
      }
      this.echartList = data
      console.log(`this.echartList`, this.echartList)
    },
  }
}
</script>

<style lang="scss" scoped>
.statisticalChartsContainer {
  font-size: 0;
  text-align: center;
  overflow: hidden;
  width: 100%;
  height: 100%;

  .chartItem {
    width: 100%;
    height: 100%;

    .itemBox {
      width: 100%;
      height: 100%;

      .chartBox {
        width: 100%;
        height: 100%;
        background: rgba(29, 55, 82, 0.85);
      }
    }
  }
}
</style>
